import _ from 'lodash'
import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import VueMeta from 'vue-meta'
import './utils/logger'
import App from './App.vue'
import router from './router/routes'
import store from './store'
import i18n from './i18n'
import eventBus from './utils/eventBus'
import VueClipboard from 'vue-clipboard2'
import directives from './directives'
import * as filters from './components/filters' // global filters
import plugins from '@/plugins'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont.js'
import './assets/iconfont/icon-svg.css'
import './assets/scss/commonAdapter.scss'
import './assets/onboarding_iconfont/iconfont.css'
import 'moment/locale/zh-cn'
import 'moment/locale/zh-hk'
import 'moment/locale/zh-tw'

Vue.config.productionTip = false

_.invokeMap(plugins, 'setup')

_.forEach(filters, (filter, filterName) => {
  Vue.filter(filterName, filter)
})

_.forEach(directives, (directive) => {
  Vue.use(directive)
})

Vue.prototype.$eventBus = eventBus // Global event bus

Vue.prototype.hasAnyPermission = store.getters['account/hasAnyPermission']

Vue.prototype.reloadPage = function reloadPage () {
  eventBus.$emit('reloadPage')
}

Vue.prototype.$DjangoStaticUrl = function staticUrl (url) {
  if (!url) {
    return url
  }
  if (url.startsWith('/')) {
    url = url.substr(1)
  }
  return process.env.VUE_APP_BASE_URL + 'static/' + url
}

Vue.prototype.$DjangoMediaUrl = function mediaUrl (url) {
  if (!url) {
    return url
  }
  if (url.startsWith('/')) {
    url = url.substr(1)
  }
  return process.env.VUE_APP_BASE_URL + 'media/' + url
}

Vue.prototype.$DjangoBaseUrl = function baseUrl (url) {
  if (!url) {
    return url
  }
  if (url.startsWith('/')) {
    url = url.substr(1)
  }
  return process.env.VUE_APP_BASE_URL + url
}

Vue.prototype.getCookie = function getCookie (cookieName) {
  const strCookie = document.cookie
  const arrCookie = strCookie.split('; ')

  for (let i = 0; i < arrCookie.length; i++) {
    const arr = arrCookie[i].split('=')
    if (arr[0] === cookieName) {
      return arr[1]
    }
  }

  return ''
}

Vue.use(VueMeta)
Vue.use(VueQuillEditor)

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#main')
